export const CHECKLIST_INPUT_TYPES = ["text", "number", "textarea"];

export function normalizeInputFields(raw) {
  if (!Array.isArray(raw) || raw.length === 0) return [];

  const seen = {};
  return raw
    .map((entry) => {
      if (!entry || typeof entry !== "object") return null;
      const label = String(entry.label || "").trim();
      if (!label) return null;

      let key = String(entry.key || "")
        .trim()
        .replace(/\s+/g, "_")
        .toLowerCase();
      if (!key) {
        key = label
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "_")
          .replace(/^_|_$/g, "");
      }
      if (!key) key = "field";
      const base = key;
      let idx = 2;
      while (seen[key]) {
        key = `${base}_${idx}`;
        idx += 1;
      }
      seen[key] = true;

      const inputType = CHECKLIST_INPUT_TYPES.includes(entry.input_type)
        ? entry.input_type
        : "text";

      return {
        key,
        label,
        input_type: inputType,
        required: Boolean(entry.required),
        ...(entry.unit ? { unit: String(entry.unit).trim() } : {}),
        ...(entry.placeholder
          ? { placeholder: String(entry.placeholder).trim() }
          : {}),
      };
    })
    .filter(Boolean);
}

export function normalizeInputValues(raw, fieldDefs = []) {
  const values =
    raw && typeof raw === "object" && !Array.isArray(raw) ? raw : {};
  const keys = (fieldDefs || []).map((f) => f.key).filter(Boolean);
  if (!keys.length) return {};

  return keys.reduce((acc, key) => {
    const val = values[key];
    if (val != null && String(val).trim() !== "") {
      acc[key] = String(val).trim();
    }
    return acc;
  }, {});
}

export function inputFieldsComplete(fieldDefs, values) {
  const defs = normalizeInputFields(fieldDefs);
  const vals = normalizeInputValues(values, defs);
  return defs.every((field) => !field.required || Boolean(vals[field.key]));
}

export function missingRequiredInputFields(fieldDefs, values) {
  const defs = normalizeInputFields(fieldDefs);
  const vals = normalizeInputValues(values, defs);
  return defs.filter((field) => field.required && !vals[field.key]);
}

export function newTemplateInputField(label = "") {
  return {
    key: "",
    label,
    input_type: "text",
    required: false,
    unit: "",
    placeholder: "",
  };
}
